export default function WhatsAppIcon() {
  const whatsappNumber = "919876093934"; // apna number

  return (
    <a
      href={`https://wa.me/${whatsappNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] p-4 rounded-full shadow-lg hover:scale-110 transition-transform"
      aria-label="Chat on WhatsApp"
    >
      {/* WhatsApp SVG Icon */}
      <svg
        viewBox="0 0 24 24"
        className="w-6 h-6 fill-white"
      >
        <path d="M20.5 3.5A11.9 11.9 0 0 0 12 0C5.4 0 .1 5.3.1 11.9c0 2.1.6 4.2 1.7 6L0 24l6.3-1.7a11.9 11.9 0 0 0 5.7 1.5h.1c6.6 0 11.9-5.3 11.9-11.9 0-3.2-1.3-6.2-3.5-8.4zM12 21.4a9.4 9.4 0 0 1-4.8-1.3l-.3-.2-3.7 1 1-3.6-.2-.4a9.4 9.4 0 1 1 17.4-4.7c0 5.2-4.2 9.4-9.4 9.4zm5.2-7c-.3-.1-1.8-.9-2.1-1s-.5-.1-.7.1-.8 1-.9 1.1-.3.2-.6.1a7.7 7.7 0 0 1-2.3-1.4 8.6 8.6 0 0 1-1.6-2c-.2-.3 0-.4.1-.6.1-.1.3-.3.4-.5s.1-.3.2-.5 0-.3-.1-.5-.7-1.8-1-2.4c-.3-.7-.6-.6-.8-.6h-.7c-.2 0-.5.1-.8.4s-1 1-1 2.5 1 2.9 1.1 3.1 2 3.1 4.9 4.4c.7.3 1.3.5 1.8.6.8.3 1.6.2 2.2.1.7-.1 1.8-.7 2-1.4s.2-1.3.2-1.4-.2-.2-.5-.3z" />
      </svg>
    </a>
  );
}


// export default function WhatsAppIcon() {
//   const whatsappNumber = "919876093934"; // ← YAHAN APNA NUMBER DAAL DENA

//   return (
//     <a
//       href={`https://wa.me/${whatsappNumber}`}
//       target="_blank"
//       rel="noopener noreferrer"
//       className="fixed bottom-6 right-6 z-50 bg-[#25D366] p-4 rounded-full shadow-lg hover:scale-110 transition-transform"
//       aria-label="Chat on WhatsApp"
//     >
//       <span className="material-symbols-outlined text-white text-3xl">chat</span>
//     </a>
//   );
// }